import React, { Component } from 'react';
import {
    EmvioCard as Card,
    EmvioRow as Row,
    EmvioTabs as Tabs
} from '@nexio/emvio-util-ui';
import { locationShape, historyShape } from '../../utils/propTypes';
import { withRouter } from 'react-router';
import UserSettings from '../UserSettings/UserSettings';
import NotificationSettings from '../NotificationSettings/NotificationSettings';
import UserManagement from '../UserManagement/UserManagement';
import MerchantManagement from '../MerchantManagement/MerchantManagement';
import PaymentRouting from '../PaymentRouting/PaymentRouting.js';
import WebhookLog from '../WebhookLog/WebhookLog';
import SettingsMenu from './SettingsMenu/SettingsMenu';
import './Settings.scss';

export class Settings extends Component {
    static propTypes = {
        history: historyShape,
        location: locationShape
    };

    constructor(props) {
        super(props);
        this.handleSelectTab = this.handleSelectTab.bind(this);
        this.mapURLToIndex = this.mapURLToIndex.bind(this);
    }

    handleSelectTab(selectedTabIndex) {
        switch (selectedTabIndex) {
            case 0:
                this.props.history.replace('/settings/details');

                return;
            case 1:
                this.props.history.replace('/settings/notifications');

                return;
            case 2:
                this.props.history.replace('/settings/userManagement');

                return;
            case 3:
                this.props.history.replace('/settings/merchantManagement');

                return;
            case 4:
                this.props.history.replace('/settings/routeManagement');

                return;
            case 5:
                this.props.history.replace('/settings/webhookLog');

                return;
            default:
                return;
        }
    }

    mapURLToIndex() {
        const { pathname } = this.props.location;
        switch (pathname) {
            case '/settings/details':
                return 0;
            case '/settings/notifications':
                return 1;
            case '/settings/userManagement':
                return 2;
            case '/settings/merchantManagement':
                return 3;
            case '/settings/routeManagement':
                return 4;
            case '/settings/webhookLog':
                return 5;
            default:
                return 0;
        }
    }

    render() {
        return (
            <Row className="emvio-settings">
                <SettingsMenu/>
                <Card className="grow-height">
                    <div className="mobile-header-wrapper">
                        <div onClick={this.props.history.goBack} className="mobile-header">
                            <div className="icon">keyboard_backspace</div>
                            <div className="text">Settings</div>
                        </div>
                    </div>
                    <Tabs
                        defaultIndex={this.mapURLToIndex()}
                        onSelect={this.handleSelectTab}
                        tabs={[
                            {
                                header: 'User Details',
                                icon: <span className="icon-man-solid"/>,
                                content: (<UserSettings/>)
                            },
                            {
                                header: 'Notifications',
                                icon: <span className="icon-notification-solid"/>,
                                content: (<NotificationSettings/>)
                            },
                            {
                                header: 'User Management',
                                icon: <span className="icon-group-solid"/>,
                                content: (<UserManagement/>)
                            },
                            {
                                header: 'Merchant Management',
                                icon: <span className="icon-lock-solid"/>,
                                content: (<MerchantManagement/>)
                            },
                            {
                                header: 'Payment Routing',
                                icon: <span className="icon-settings"/>,
                                content: (<PaymentRouting/>)
                            },
                            {
                                header: 'Webhook Log',
                                icon: <span className="icon-history"/>,
                                content: (<WebhookLog/>)
                            }
                        ]}
                    />
                </Card>
            </Row>
        );
    }
}

export default withRouter(Settings);
